module.exports = __webpack_public_path__ + "media/app/components/RatingModal/Mascot-4.d0663bf1.svg";